import { render } from "./DecorationProcessDpiThresholds.vue?vue&type=template&id=56c282c6&scoped=true"
import script from "./DecorationProcessDpiThresholds.vue?vue&type=script&lang=js"
export * from "./DecorationProcessDpiThresholds.vue?vue&type=script&lang=js"

import "./DecorationProcessDpiThresholds.vue?vue&type=style&index=0&id=56c282c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c282c6"]])

export default __exports__